import { useRef, useEffect, useMemo } from 'react'
import { InputLabel } from "../partials/input-label";
import { InputValidationError } from "../partials/input-validation-error";
import 'cleave.js/dist/addons/cleave-phone.tr.js'

const TextareaInput = ({
	inputType: inputTypeProp, onChangePlainValue, onChange, initialized,
	className, label, validationError,
	autoComplete, value, mask, innerContent, showCounter: showCounterRaw, counterTemplate,
	...props
}) => {
	const inputRef = useRef();

	// Set initial plain value.
	const plainValue = useMemo(() => {
		return value;
	}, [value, inputTypeProp])

	useEffect(() => {
		onChangePlainValue(plainValue);
	}, [plainValue])

	const handleChange = e => {
		onChange(e.target.value);
	}

	const {
		showCounter,
		counterText,
	} = useMemo(() => {
		let counterText;

		if(props.maxLength && showCounterRaw) {
			counterText = counterTemplate.replace('{count}', value?.length ?? 0).replace('{max}', props.maxLength).replace('{left}', props.maxLength - (value?.length ?? 0));
		}

		return {
			showCounter: !!counterText,
			counterText,
		}
	}, [props.maxLength, showCounterRaw, value, counterTemplate])

	useEffect(() => {
		if (inputRef.current && typeof inputRef.current === 'function' && inputRef.current.matches(':-internal-autofill-selected')) {
			inputRef.current.click();
		}
	}, [])

	return (
		<div className={className}>
			<InputLabel label={label} name={props.id} />
			<div className="inputwrap-innerwrap">
				{innerContent}
				<textarea
					ref={inputRef}
					onChange={handleChange}
					className={'inputwrap-input'}
					autoComplete={autoComplete || 'off'}
					value={value}
					{...props} />
			</div>
			{showCounter &&
				<span className="inputwrap-counter">{counterText}</span>
			}
			<InputValidationError error={validationError} />
		</div>
	)
}

TextareaInput.defaultProps = {
	counterTemplate: 'Kalan: {count}/{max}',
}

export default TextareaInput;